module.exports = __webpack_public_path__ + "static/white_dragon-1bf00f8d3a910f4dece52b1ee7265031.jpg";